var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { styled } from '@workday/canvas-kit-react-common';
export var buttonLabelDataClassName = 'button-label-data';
var Container = styled('span')({
    position: 'relative',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontWeight: 400,
});
export var ButtonLabelData = function (props) { return (React.createElement(Container, __assign({ className: buttonLabelDataClassName }, props))); };
